import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../Common/CommonCardFooter";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HorizontalStyles } from "../../../../Constant";
import { HORIZONTAL_STYLE } from "../../../../Data/FormControl/MegaOptions";
import HorizontalStyleForm from "./HorizontalStyleForm";

const HorizontalStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={HorizontalStyles} span={HORIZONTAL_STYLE} />
        <CardBody>
          <HorizontalStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" btn1Class='m-r-15' color2="light" />
      </Card>
    </Col>
  )
};

export default HorizontalStyle;
